module.exports = __webpack_public_path__ + "static/media/IrockPromoMobile.6c2a8828.webm";